module.exports = __webpack_public_path__ + "img/ico comer.f301abc2.svg";